import React from "react";
import orangeIndicator from "@src/assets/svg/orange-color-indicator-icon.svg";
import { Button } from "@src/components/atoms/buttons/button/button";
import styles from "./ota-firmware-installation-in-progress.module.scss";
import { ActiveInstallationProcessPayload } from "@src/types/ota-update";
import { useOtaFirmwareInstallationInProgress } from "./use-ota-firmware-installation-in-progress";

const cssClassName = "ota-firmware-installation-in-progress";

interface OTAFirmwareInstallationInProgressProps {
  activeInstallationData?: ActiveInstallationProcessPayload | null;
}

export default function OTAFirmwareInstallationInProgress({
  activeInstallationData,
}: OTAFirmwareInstallationInProgressProps) {
  const { texts, handleShowDetails } = useOtaFirmwareInstallationInProgress({
    activeInstallationData,
  });

  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__content`]}>
        <img
          src={orangeIndicator}
          alt=""
          className={styles[`${cssClassName}__indicator`]}
        />
        <div className={styles[`${cssClassName}__text`]}>
          <span className={styles[`${cssClassName}__title`]}>
            {texts.titleHasItemName ? (
              <>
                {texts.titlePrefix}
                <span
                  className={styles[`${cssClassName}__title-item-name`]}
                  title={texts.itemName}
                >
                  {texts.itemName}
                </span>
                {texts.titleSuffix}
              </>
            ) : (
              texts.title
            )}
          </span>
          <span className={styles[`${cssClassName}__description`]}>
            {texts.description}
          </span>
        </div>
      </div>

      <Button
        text={texts.showDetailsButtonText}
        variant="secondary"
        fun={handleShowDetails}
      />
    </div>
  );
}
